export enum EjariLookUp {
	TENANT_TYPES = "GetTenantTypes",
	LICENSE_ISSUERS = "GetLicenseIssuers",
	LICENSE_STATES = "GetLicenseStates",
	EMIRATES = "emirates",
	COUNTRY = "Countries",
	GENDER = "GetGenderTypes",
	EJARI_CONTRACT_BLOCK_REASONS = "EjariContractBlockReasons",
	BANKS = "banks",
	TERMINATE_REASONS = "TerminationReasons",
	AREAS = "area",
	TERMS_CONDITIONS = "GetMobileTerms",
	REG_REASON = "GetRegistrationReasons",
	ALL_PROPERTY_USAGES = "AllPropertyUsages",
	HAZARDS_MAT_CLASSIFICATION = "hazardousmaterialclassification",
	MC_TERMINATION_REASONS = "mcterminationreasons",
	MC_COMPANIES = "managementcompanies",
	MC_TYPES = "managementcontracttypes",
	MC_ACTIVITIES = "managementcontractactivities",
	MC_RESPONSIBILITIES = "mccontractresponsibilities",
	MC_PAYMENT_TYPES = "managementcontractpaymenttypes",
}

export enum ContractTypes {
	MANAGEMENT_CONTRACT = 1,
	TENANCY = 2,
}